// extracted by mini-css-extract-plugin
module.exports = {"photocard":"Images_photocard__2255-","qcIssues":"Images_qcIssues__3WQXd","hidden":"Images_hidden__8bNjp"};